import { bookingPayment } from "../data/siteData";

export default function PayPalCheckout({ bookingId }) {
  return (
    <div className="payment-page">
      <div>
        <p className="eyebrow">Booking saved</p>
        <h2 id="payment-title">Make Your Payment</h2>
        <p>
          Your details are in. Complete the {bookingPayment.displayAmount} payment
          through PayPal, then I will match the payment to this booking reference.
        </p>
      </div>

      <div className="payment-summary" aria-label="Payment summary">
        <div>
          <span>Booking reference</span>
          <strong>{bookingId}</strong>
        </div>
        <div>
          <span>Amount</span>
          <strong>
            {bookingPayment.displayAmount} {bookingPayment.currency}
          </strong>
        </div>
        <div>
          <span>Payment method</span>
          <strong>PayPal</strong>
        </div>
      </div>

      <div className="payment-page-actions">
        <a
          className="button button-primary"
          href={bookingPayment.paypalUrl}
          target="_blank"
          rel="noreferrer"
        >
          Pay With PayPal
        </a>
        <span>Card payments coming soon.</span>
      </div>

      <p className="booking-note">
        Keep this tab open until payment is done. If PayPal asks for a note, add
        the booking reference above.
      </p>
    </div>
  );
}
